/* 🤖 this file was generated by svg-to-ts */
export const matIconFileCopy: {
  name: 'file-copy';
  data: string;
} = {
  name: 'file-copy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"/></svg>`
};
